import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { PATH } from '#const/path';
import TokenController from '#utils/tokenController';

interface Params {
  redirectUrl?: string;
}

/**
 * 로그인 유저가 세션이 필요없는 페이지에 접근한 경우 리다이렉트 처리하는 hooks
 *
 */
export function useAuthRedirect(params?: Params) {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!!TokenController.accessToken) {
      navigate(params?.redirectUrl ?? PATH.HOME);
    }

    setIsLoading(false);
  }, []);

  return isLoading;
}
